import api from './api';

const authService = {
  // Perfil del usuario autenticado (incluye whatsappOptIn)
  getMe: async () => {
    const response = await api.get('/auth/me');
    return response.data;
  },

  // Actualizar consentimiento de WhatsApp
  updateWhatsappOptIn: async (whatsappOptIn) => {
    const response = await api.put('/auth/whatsapp-opt-in', { whatsappOptIn });
    return response.data;
  },

  // Actualizar número de Nequi (solo médicos)
  updateNequiNumber: async (nequiNumber) => {
    const response = await api.put('/auth/nequi', { nequiNumber });
    return response.data;
  },

  // Actualizar documento de identificación (cédula)
  updateDocumentNumber: async (documentType, documentNumber) => {
    const response = await api.put('/auth/document', { documentType, documentNumber });
    return response.data;
  }
};

export default authService;
